import { StampedModel, ResourceFactory } from '../services/';

class Stationcategory extends StampedModel {
  public parent:      number = null;
  public name:        string = '';
  public stations_count: number;
}

const StationcategoryFactory = ResourceFactory.create<Stationcategory>(Stationcategory, 'stationcategory');

export { Stationcategory, StationcategoryFactory };
